import { FleLayout } from "components/views/fle/FleLayout"
import { Spacer } from "components/views/atoms/Atoms"
import { IlloUnderwaterChecklist } from "components/views/atoms/Illustrations"
import { LeftArrowAndSpace, SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { Body } from "components/views/atoms/Bodies"
import { BottomLinkMobileOnlyStyledWrapper } from "components/views/atoms/Links"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import React from "react"
import L10n from "lib/carrot-l10n"
import { Container, FlexContainer } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export default function GuidanceInformational({ onBack, onComplete, carrotLite }) {
  return (
    <FleLayout
      bottomContent={
        <FlexContainer stack="huge" justifyContent="center">
          <BottomLinkMobileOnlyStyledWrapper>
            <ButtonPrimary onClick={onComplete}>{l`Create my account`}</ButtonPrimary>
          </BottomLinkMobileOnlyStyledWrapper>
        </FlexContainer>
      }
    >
      <LeftArrowAndSpace onBack={onBack} />
      <FlexContainer justifyContent="center">
        <IlloUnderwaterChecklist />
      </FlexContainer>
      <SpacerSwitcher />
      <SwitchH1ToH2>Enjoy personal, dynamic&nbsp;guidance</SwitchH1ToH2>
      <Spacer height={0.5} />
      <Container stack="tiny">
        <Body color="black-80">
          {carrotLite
            ? "When you're ready to access experts, providers, and more, simply tell us about your family-forming " +
              "journey and we'll design a personalized plan to help guide you along every twist and turn in the road."
            : "When you're ready to access your Carrot funds, experts, and providers, simply tell us about your family-forming " +
              "journey and we'll design a personalized plan to help guide you along every twist and turn in the road."}
        </Body>
      </Container>
      <Container stack="medium">
        <Body color="black-80">{`As your journey evolves, so will your plan.`}</Body>
      </Container>
    </FleLayout>
  )
}
